import { UnknownAction } from '@reduxjs/toolkit'
import { Translation } from 'locale'
import {
  ClientEventAction,
  ClientLoginAction,
  ClientCrudEventAction,
  ClientSubscribeAction,
  ClientUnsubscribeAction,
  EntityTypeEnum,
  ClientDatabaseReportAction,
  ClientPermissionsReportAction,
  ClientUpdateCollateralsAction,
  ClientUpdateIssuerOrganisationAction
} from 'api'

export type EntityTypeIdRecord = Record<EntityTypeEnum, string>
export type CorrelatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord | null) => unknown

export enum PendingWorkflowTypeEnum {
  NEW_WORKFLOW = 'NEW_WORKFLOW',
  CLONE_WORKFLOW = 'CLONE_WORKFLOW',
  EDIT_WORKFLOW = 'EDIT_WORKFLOW',
  ADD_ENTITY = 'ADD_ENTITY'
}

export interface PendingWorkflow {
  workflowType: PendingWorkflowTypeEnum
  correlatedResponseCallback?: CorrelatedResponseCallback
}

export interface NotificationStore {
  growls: Growl[]
  dialogs: Dialog[]
  pendingActions: Record<
    string,
    | ClientEventAction
    | ClientCrudEventAction
    | ClientSubscribeAction
    | ClientUnsubscribeAction
    | ClientLoginAction
    | ClientDatabaseReportAction
    | ClientPermissionsReportAction
    | ClientUpdateCollateralsAction
    | ClientUpdateIssuerOrganisationAction
  >
  pendingWorkflows: Record<string, PendingWorkflow>
}

export enum NotificationType {
  Error = 'Error',
  Warning = 'Warning',
  Success = 'Success',
  Confirm = 'Confirm',
  Info = 'Info'
}

export interface Notification {
  id: string
  type: NotificationType
  title?: Translation
  titleText?: string
  message?: Translation
  messageArgs?: any
  messageText?: string
  messageComponent?: JSX.Element
  targetWindowId: string
}

export interface Growl extends Notification {
  timeout?: number
}

export type ResponseMapResponse = UnknownAction | (() => unknown)

export interface Dialog extends Notification {
  buttons: Translation[]
  responseMap?: { [button in Translation]?: ResponseMapResponse[] }
  defaultButton?: Translation
  cancelButton?: Translation
}

export interface CustomDialog {
  id: string
  targetWindowId: string
  component: JSX.Element
}
